let QueryDetailsService = function ($http, $q, $rootScope) {

    var queryTypeOptions = {};

    let types = function () {
        var deferred = $q.defer();
        if (!queryTypeOptions.Promise) {
            $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
            queryTypeOptions = $http.get(WEBSERVICEURL + '/dataagility/api/service.queryaudittype/parentChild')
                .then(function successCallback(response) {
                    queryTypeOptions = response.data;
                    deferred.resolve(queryTypeOptions);
                },
                function errorCallback(response) {
                  if (response.status === 401) {
                    window.location.replace(window.location.origin + '/login?logout=true');
                  }
                });
        } else {
            deferred.resolve(queryTypeOptions);
        }
        return deferred.promise;
    }

    return { types };
};

export default QueryDetailsService;



// WEBPACK FOOTER //
// ./client/app/common/services/queryDetails.service.js